'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = watcher;

function watcher() {
  var observers = [];
  return {
    watch: watch,
    notify: notify
  };

  function watch(fn) {
    if (typeof fn === 'function') {
      observers.push(fn);
    }

    return function () {
      observers = observers.filter(function (someFn) {
        return someFn !== fn;
      });
    };
  }

  function notify(value) {
    observers.forEach(function (fn) {
      return fn(value);
    });
  }
}